import { css } from 'styled-components';

export const codeTextMixin = css`
  font-family: Courier, monospace;
  color: ${props => props.theme.colors.content.secondary};
  background-color: ${props => props.theme.colors.background.secondary};
  padding: 0 4px;
  border-radius: 4px;
`;
